/**
 * The main api service
 */
import http from '@util/http';
import {common, core} from '../req';

export async function queryOrgList(params) {
  return http.get(core.CORE_ORG_LIST, params);
}

/**
 * 所有组织列表
 */
export async function queryOrgAllList(params) {
  return http.get(core.ORG_LIST_ALL, params);
}

export async function queryOrgCompanyList(params) {
  return http.get(core.CORE_ORG_COMPANY_LIST, params);
}

/**
 * 获取公司
 */
export async function queryAllCompany(params) {
  params.type = 1;
  return http.get(core.ORG_LIST_ALL, params);
}

/**
 * 获取公司
 */
export async function queryCompany(params) {
  params.type = 1;
  return http.get(core.CORE_ORG_LIST, params);
}

export async function queryOrgInfo(params) {
  return http.get(core.ORG_INFO, params);
}

export async function queryOrgTree() {
  return http.get(core.CORE_ORG_TREE);
}

export async function queryByOrgTree(params) {
  return http.get(core.CORE_BY_ORG_TREE, params);
}

export async function queryOrgEnableTree() {
  return http.get(core.CORE_ORG_ENABLE_TREE);
}

export async function queryMoveOrg(params) {
  return http.post(core.CORE_ORG_MOVE, params);
}

export async function queryAddOrg(params) {
  return http.post(core.CORE_ORG_ADD, params);
}

export async function queryUpdateOrg(params) {
  return http.post(core.CORE_ORG_UPDATE, params);
}

export async function queryDeleteOrg(params) {
  return http.get(core.CORE_ORG_DELETE, params);
}

export async function queryDisableOrg(params) {
  return http.get(core.CORE_ORG_DISABLE, params);
}

export async function queryEnableOrg(params) {
  return http.get(core.CORE_ORG_ENABLE, params);
}

export async function queryConfigOrg(params) {
  return http.post(common.CORE_ORG_CONFIG, params);
}

export async function queryConfigOrgOp() {
  return http.get(common.CORE_ORG_CONFIG_OPTIONS);
}

export async function queryConfigOrgInfo(params) {
  return http.get(common.PUP_ORG_CONFIG_INFO, params);
}



// WEBPACK FOOTER //
// ./src/api/core/org.js